import {findLast} from "lodash";
import {matchPath} from "react-router-dom";

export interface UrlInfo {
  url: string;
  path: string;
  titleKey: string;
}

export type Urls = Record<string, UrlInfo>;

export const getUrlInfo = (urls: Urls, pathname: string): UrlInfo | undefined => {
  return findLast(urls, (url) => !!matchPath({path: url.url}, pathname));
};
